import { get } from '../Services/http';
import { CLICK_COLLECT_ORGS, CLICK_COLLECT_ORGS_ERROR } from '../constants';
import { catchError } from './Error.action';

export const getClickCollectOrgs = (variantId) => (dispatch, getState) => {  
    return get(`/api/clickcollect/getclickcollectorgs?variantId=${variantId}&channelId=${window.__litium.constants.channelId}`)
    .then((response) => response.json())
    .then((result) => {
        dispatch(receive(result));
    })
    .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))));
};

export const receive = (listItem) => ({
    type: CLICK_COLLECT_ORGS,
    payload: {
        organizations: listItem
    }
});

export const loadError = (error) => ({
    type: CLICK_COLLECT_ORGS_ERROR,
    payload: {
        error,
    },
});